import React from 'react'
import { Link } from 'react-router-dom'
import Activate from '../../../purchase/stepsContext/Activate'

const Activation = () => {
    return (
        <div className='activation-context'>
            <Activate isExternalActivation={true} />

        </div>
    )
}

export default Activation